import type React from 'react';
import { Typography, Stack, Box } from '@mui/material';

import { TotalPanel } from '../request/Tests';
import type { TestProps } from '../../models';
import { fCurrency } from '../../utils/formatNumber';

interface TestsProps {
	tests: TestProps[];
}

/*
 Selected tests total summary
*/
export const TestSummary = ({ tests }: TestsProps) => {
	return (
		<Stack spacing={2}>
			{tests.map((test) => (
				<Stack key={test.id} direction="row" justifyContent="space-between" alignItems="flex-start">
					<Box>
						<Typography variant="body1">
							{test.quantity} <strong>×</strong> {test.name}
						</Typography>
					</Box>
					<Box sx={{ textAlign: 'right' }}>
						<Typography variant="body1" sx={{ fontWeight: 'fontWeightBold', color: 'text.primary' }}>
							{fCurrency(test.price * (test.quantity || 1))}
						</Typography>
						<Typography variant="body2">{fCurrency(test.price)} ea</Typography>
					</Box>
				</Stack>
			))}
			<TotalPanel tests={tests} />
		</Stack>
	);
};
